module.exports = __webpack_public_path__ + "static/media/edge.8be9f48b.svg";